import React from 'react';
import useDarkMode from 'use-dark-mode';

import { ThemeLayout } from 'src/theming';

import { CustomerAddForm } from 'src/customers/customer-add-form/customer-add-form';

export const CustomerAddFormPage = (): JSX.Element => {
    const darkMode = useDarkMode();
    return (
        <ThemeLayout darkMode={darkMode}>
            <CustomerAddForm />
        </ThemeLayout>
    );
};
